/* mo-contact-sohub.js — hero letter rise, time-of-day greeting,
   open/closed pill, 3-step counter wizard (call/email/visit only — no SMS),
   scroll reveals. Self-contained; does not touch mo-fx.js hooks. */
(function () {
  var root = document.querySelector('[data-mo-csh]');
  if (!root || root.dataset.moCshInit) return;
  root.dataset.moCshInit = '1';

  var TEL = root.dataset.phone || '';
  var TEL_DISPLAY = root.dataset.phoneDisplay || TEL;
  var EMAIL = root.dataset.email || '';
  var LOCATION = root.dataset.location || 'Vestavia Hills, Alabama';

  /* Store hours (Mon–Sat 9–6, Sun closed) drive the open/closed pill only —
     the hours list itself is intentionally not shown on this page. */
  var HOURS = [
    { d: 'Sunday', o: null, c: null },
    { d: 'Monday', o: 9, c: 18 },
    { d: 'Tuesday', o: 9, c: 18 },
    { d: 'Wednesday', o: 9, c: 18 },
    { d: 'Thursday', o: 9, c: 18 },
    { d: 'Friday', o: 9, c: 18 },
    { d: 'Saturday', o: 9, c: 18 }
  ];

  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---- hero giant word: split into letters ---- */
  var giant = q('[data-csh-giant]');
  if (giant) {
    var word = giant.textContent.trim();
    giant.textContent = '';
    for (var i = 0; i < word.length; i++) {
      var s = document.createElement('span');
      s.className = 'mo-csh__ltr';
      s.style.setProperty('--i', i);
      s.textContent = word[i];
      giant.appendChild(s);
    }
  }
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { root.classList.add('is-loaded'); });
  });

  /* ---- central time helpers ---- */
  function ctNow() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' })); }
    catch (e) { return new Date(); }
  }
  function fmtHour(h) {
    var ap = h >= 12 ? 'pm' : 'am';
    var hr = h % 12; if (hr === 0) hr = 12;
    return hr + ap;
  }

  /* ---- open / closed pill ---- */
  var now = ctNow();
  var today = HOURS[now.getDay()];
  var openDot = q('[data-csh-open-dot]');
  var openText = q('[data-csh-open-text]');
  if (openDot && openText) {
    var isOpen = today.o !== null && now.getHours() >= today.o && now.getHours() < today.c;
    if (isOpen) {
      openDot.classList.add('is-open');
      openText.textContent = 'Open now til ' + fmtHour(today.c);
    } else {
      var probe = 0, next = null;
      if (today.o !== null && now.getHours() < today.o) next = today;
      while (!next && probe < 7) {
        probe++;
        var t = HOURS[(now.getDay() + probe) % 7];
        if (t.o !== null) next = t;
      }
      openText.textContent = 'Closed · opens ' + (next === today ? '' : next.d + ' ') + fmtHour(next.o);
    }
  }

  /* ---- greeting, word by word ---- */
  var h = now.getHours();
  var part = h < 12 ? 'morning' : h < 17 ? 'afternoon' : 'evening';
  var greetEl = q('[data-csh-greet]');
  if (greetEl) {
    var plain = 'Hey there! What brings you by the shop this ' + part + ' in';
    var words = plain.split(' ');
    words.forEach(function (w, idx) {
      var s = document.createElement('span');
      s.className = 'mo-csh__word';
      s.style.transitionDelay = (idx * 45) + 'ms';
      s.textContent = w;
      greetEl.appendChild(s);
    });
    var hl = document.createElement('span');
    hl.className = 'mo-csh__word mo-csh__greet-hl';
    hl.style.transitionDelay = (words.length * 45) + 'ms';
    hl.textContent = LOCATION + '?';
    greetEl.appendChild(hl);
  }

  /* ---- step machine ---- */
  var steps = qa('.mo-csh__step');
  function show(name) {
    steps.forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === name); });
    if (name === 'intents' && greetEl) {
      greetEl.classList.remove('is-on');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { greetEl.classList.add('is-on'); });
      });
    }
  }

  var FLOWS = {
    purchase: {
      title: 'Plan a purchase',
      question: 'Good call. What are you shopping for? Pick anything that fits.',
      chips: ['First deer rifle', 'Bow setup', 'Fishing gear', 'Optics and scopes', 'Gun safe', 'Ammo', 'Something else'],
      lead: 'We will have the right person ready. Read it over and send it.'
    },
    service: {
      title: 'Book service work',
      question: 'Bring it on in. What needs work?',
      chips: ['Gunsmithing', 'Bow tuning', 'Rod repair', 'Scope mounting', 'Safe delivery', 'Not sure yet'],
      lead: 'Our bench guys will know you are coming. Read it over and send it.'
    }
  };

  var currentIntent = null;
  var selected = [];
  var chipRow = q('[data-csh-chip-row]');
  var chipErr = q('[data-csh-chip-err]');

  qa('[data-csh-intent]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      currentIntent = btn.dataset.cshIntent;
      selected = [];
      if (currentIntent === 'hey') { buildSlip(); show('slip'); return; }
      var flow = FLOWS[currentIntent];
      var title = q('[data-csh-chip-title]');
      if (title) title.textContent = flow.title;
      var qEl = q('[data-csh-chip-question]');
      chipErr.textContent = '';
      qEl.textContent = '';
      flow.question.split(' ').forEach(function (w, idx) {
        var s = document.createElement('span');
        s.className = 'mo-csh__word';
        s.style.transitionDelay = (idx * 40) + 'ms';
        s.textContent = w;
        qEl.appendChild(s);
      });
      chipRow.innerHTML = '';
      flow.chips.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mo-csh__chip';
        b.textContent = c;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          var on = b.classList.toggle('is-sel');
          b.setAttribute('aria-pressed', on);
          if (on) selected.push(c);
          else selected = selected.filter(function (x) { return x !== c; });
          chipErr.textContent = '';
        });
        chipRow.appendChild(b);
      });
      show('chips');
      qEl.classList.remove('is-on');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { qEl.classList.add('is-on'); });
      });
    });
  });

  var contBtn = q('[data-csh-continue]');
  if (contBtn) contBtn.addEventListener('click', function () {
    if (!selected.length) { chipErr.textContent = 'Pick at least one so we grab the right person.'; return; }
    buildSlip(); show('slip');
  });

  qa('[data-csh-back]').forEach(function (b) {
    b.addEventListener('click', function () {
      var active = root.querySelector('.mo-csh__step.is-active');
      var cur = active ? active.dataset.step : 'intents';
      if (cur === 'slip' && currentIntent && currentIntent !== 'hey') show('chips');
      else show('intents');
    });
  });

  /* ---- counter slip (email or call only — no SMS) ---- */
  var slipMsg = q('[data-csh-slip-msg]');
  var slipName = q('[data-csh-slip-name]');
  var slipDate = q('[data-csh-slip-date]');
  if (slipDate) slipDate.textContent = now.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  function buildSlip() {
    var lead = q('[data-csh-slip-lead]');
    if (currentIntent === 'hey') {
      if (lead) lead.textContent = 'Well hey right back. Leave us a note and we will answer.';
      slipMsg.value = 'Hey y’all! Just wanted to say hello and ask about ';
    } else {
      if (lead) lead.textContent = FLOWS[currentIntent].lead;
      slipMsg.value = 'Hey Mark’s Outdoors! I’m interested in: ' + selected.join(', ') + '. ';
    }
    updateLinks();
  }
  function updateLinks() {
    var name = slipName.value.trim();
    var body = slipMsg.value + (name ? '\n— ' + name : '');
    var emailBtn = q('[data-csh-send-email]');
    if (emailBtn) {
      emailBtn.href = 'mailto:' + EMAIL +
        '?subject=' + encodeURIComponent('Counter slip from the website') +
        '&body=' + encodeURIComponent(body);
    }
  }
  if (slipMsg) slipMsg.addEventListener('input', updateLinks);
  if (slipName) slipName.addEventListener('input', updateLinks);

  /* ---- scroll reveals ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-on'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    qa('.mo-csh__rv').forEach(function (el) { io.observe(el); });
  } else {
    qa('.mo-csh__rv').forEach(function (el) { el.classList.add('is-on'); });
  }

  /* initial greet reveal */
  setTimeout(function () { if (greetEl) greetEl.classList.add('is-on'); }, 400);
})();
